import { Box, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import Card from 'components/App/LibraryCard';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { MoreButton } from './styles';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useNavigate } from 'react-router-dom';
import { createData } from 'helpers/api.services';
import { useSelector } from 'react-redux';
import { Snackbar } from 'components/shared';
import ConfirmDialog from 'components/App/ConfirmDialog';

const CardContainer = ({ id, attributes, refreshData }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.Auth);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const continueEditing = () => {
    handleClose();
    if (attributes?.published?.data) {
      let publishedDate = new Date(attributes?.published?.data?.attributes?.updatedAt);
      let projectUpdatedDate = new Date(attributes?.updatedAt);
      if (publishedDate > projectUpdatedDate) {
        setIsEdit(true);
      } else {
        handleEdit();
      }
    } else {
      handleEdit();
    }
  };

  const handleEdit = () => {
    navigate(`/studio/${id}`);
  };

  const handleLink = () => {
    navigator.clipboard.writeText(`https://stplr.superteach.org/?prj=${id}`);
    setSnackbarOpen(true);
    handleClose();
  };

  const handleCopy = async () => {
    let payload = {
      title: attributes?.title,
      project: attributes?.project,
      description: attributes?.description,
      username: attributes?.username,
      lwuser: user.user.lwId,
      lwSchoolId: user.user.lwSchoolId,
      isLifewise: false,
    };
    await createData('projects', payload);
    refreshData();
    handleClose();
  };



  const isDraft = useMemo(() => {
    if (attributes?.published?.data) {
      let publishedDate = new Date(attributes?.published?.data?.attributes?.updatedAt);
      let projectUpdatedDate = new Date(attributes?.updatedAt);
      if (publishedDate > projectUpdatedDate) {
        return 'Published';
      } else {
        return 'Draft';
      }
    }
    return 'Draft';
  }, [attributes?.published]);


  return (
    <Box
      position="relative"
      sx={{
        '&:hover .more-icon': {
          display: 'flex',
        },
      }}>
      <Card
        tag={isDraft}
        image={''}
        name={attributes?.title}
        timeValue={attributes?.createdAt}
        ratio={'16/9'}
        isDate={true}
        bgColor={'#1ed4c1'}
        padding={'0px'}
        isSlide={attributes?.project?.slides?.[0]}
      />
      <MoreButton className="more-icon" onClick={handleMenuOpen}>
        <MoreHorizIcon />
      </MoreButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <MenuItem onClick={continueEditing}>
          <ListItemIcon>
            <EditIcon sx={{ color: 'background.paper' }} />
          </ListItemIcon>
          <ListItemText>Continue Editing</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleCopy}>
          <ListItemIcon>
            <ContentCopyIcon sx={{ color: 'background.paper' }} />
          </ListItemIcon>
          <ListItemText>Make a copy</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleLink}>
          <ListItemIcon>
            <ContentCopyIcon sx={{ color: 'background.paper' }} />
          </ListItemIcon>
          <ListItemText>Copy the link</ListItemText>
        </MenuItem>
      </Menu>
      <Snackbar open={snackbarOpen} handleClose={() => setSnackbarOpen(false)} message={'Link copied to clipboard!'} />
      <ConfirmDialog
        open={isEdit}
        onClose={() => setIsEdit(false)}
        onConfirm={handleEdit}
        title={'Edit'}
        buttonTitle={'Confirm'}
        showCancelButton={true}
        showConfirmButton={true}
      >
        <Typography variant='body2'>
          Are you sure you want to make changes to the lesson LifeWise? You will not be able to revert to the original lesson.
        </Typography>
      </ConfirmDialog>
    </Box>
  );
};

export default CardContainer;
